import React from 'react';
import styled from 'styled-components'

const Container = styled.div`
    // max-width: 1440px;
    padding-left: 80px;
    padding-right: 80px;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        padding-left: 20px;
        padding-right: 20px;
    }
`

const Footer = () => {
    return (
        <footer class="cnn-footer">
            <Container>
                <div class="cnn-footer__logo-wrapper">
                <svg class="cnn-footer__logo" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 440.6 440.6">
                    <rect style={{ fill:'#CB1517' }} width="440.6" height="440.6"/>
                    <path
                    style={{ fill:'#FFFFFF' }}
                    d="M89.5,220.3c0-18.5,15-33.6,33.6-33.6h25.5v-19h-25.7c-29,0-52.6,23.6-52.6,52.6c0,29,23.6,52.6,52.6,52.6
                    l49.4,0c2.8,0,5-2.7,5-5v-97.4c0-5.4,3.4-9.9,8.4-11.3c4.3-1.2,10.3,0,14.3,6.8c0.2,0.3,12.3,21.2,30.8,53.1
                    c14.5,25,29.5,50.9,29.8,51.4c1.6,2.6,3.7,3.9,5.7,3.3c1.3-0.3,2.8-1.6,2.8-3.9v-99.5c0-5.4,3.4-9.9,8.3-11.3
                    c4.2-1.2,10.2,0,14.2,6.8c0.2,0.3,10.9,18.8,28.6,49.3c15.6,26.9,31.8,54.8,32.1,55.3c1.6,2.6,3.7,3.9,5.7,3.3
                    c1.3-0.3,2.8-1.6,2.8-3.9v-129h-19.1v76.8c0,0-31.8-54.8-33.3-57.3c-20.2-34.3-58.4-20.1-58.4,9.4v47.9c0,0-31.8-54.8-33.3-57.3
                    c-20.2-34.3-58.4-20.1-58.4,9.4v78.5c0,2.9-2.1,5.3-5.3,5.3h-30C104.5,253.8,89.5,238.8,89.5,220.3z"/>
                    <path
                    style={{ fill:'#FFFFFF' }}
                    d="M368.3,141.1v129c0,5.4-3.4,9.9-8.4,11.3c-0.9,0.2-1.9,0.4-3,0.4c-3.8,0-8.2-1.9-11.3-7.2
                    c-0.2-0.3-12.8-22.1-32.1-55.3c-13.9-24-28.3-48.8-28.6-49.2c-1.6-2.6-3.7-3.9-5.7-3.3c-1.3,0.3-2.7,1.6-2.7,3.9V270
                    c0,5.4-3.4,9.9-8.4,11.3c-4.3,1.2-10.3,0-14.3-6.8c-0.2-0.3-11.9-20.5-29.8-51.4c-15-25.9-30.5-52.6-30.8-53.1
                    c-1.6-2.6-3.7-3.9-5.7-3.3c-1.3,0.3-2.8,1.6-2.8,3.9l0,97.4c0,6.7-5.9,12.6-12.6,12.6l-49.4,0c-33.2,0-60.2-27-60.2-60.2
                    c0-33.2,27-60.2,60.2-60.2h25.7v-19h-25.6c-43.7,0-79.2,35.5-79.2,79.2c0,43.7,35.5,79.2,79.2,79.2h49.9c19,0,31.2-11.1,31.1-31.6
                    v-45.2c0,0,31.8,54.8,33.3,57.3c20.2,34.3,58.4,20.1,58.4-9.4v-47.9c0,0,31.8,54.8,33.3,57.3c20.2,34.3,58.4,20.1,58.4-9.4V141.1
                    H368.3z"/>
                </svg>
                </div>
                <div class="cnn-footer__links">
                <a href="https://edition.cnn.com/terms" target="_blank" rel="noopener noreferrer">Terms of Use</a>
                <a href="https://edition.cnn.com/privacy1?no-st=9999999999" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                <a href="https://edition.cnn.com/privacy1?no-st=9999999999" target="_blank" rel="noopener noreferrer">Ad Choices</a>
                <a href="https://edition.cnn.com/about" target="_blank" rel="noopener noreferrer">About Us</a>
                </div>
                <p><samll>©  Cable News Network. Turner Broadcasting System, Inc. <span>All Rights Reserved.</span></samll></p>
            </Container>
        </footer>
    );
};

export default Footer;